import React, { useState } from "react";
import PropTypes from "prop-types";

import Grid from "core/Grid";
import {
    CardNumberGrid,
    MonthYearGrid,
    CvcGrid,
    NameGrid,
    PostalGrid
} from "./styles";

const FormInputLayout = ({
    cardNumberField,
    mmyyField,
    cvcField,
    nameField,
    postalField
}) => {
    return (
        <Grid desktopSpacing={0}>
            <CardNumberGrid item sm={12} md={12} lg={12}>
                {cardNumberField}
            </CardNumberGrid>

            <MonthYearGrid item>{mmyyField}</MonthYearGrid>

            <CvcGrid item>{cvcField}</CvcGrid>

            <NameGrid item sm={12} md={12} lg={12}>
                {nameField}
            </NameGrid>

            <PostalGrid item>{postalField}</PostalGrid>
        </Grid>
    );
};

FormInputLayout.propTypes = {
    cardNumberField: PropTypes.element.isRequired,
    mmyyField: PropTypes.element.isRequired,
    cvcField: PropTypes.element.isRequired,
    nameField: PropTypes.element.isRequired,
    postalField: PropTypes.element.isRequired
};

export default FormInputLayout;
